'use client'

import { useIsMobile } from '@graftcode/design-system'
import * as Popover from '@radix-ui/react-popover'

import { SHARE_FEEDBACK_TEST_IDS } from '@common/common-test-ids.const'

import { useSuppressInitialOutsideInteraction } from './hooks'
import type { Props } from './ShareFeedback.types'
import { ShareFeedbackContent } from './ShareFeedbackContent'
import { useShareFeedbackPhase } from './useShareFeedbackPhase'

import styles from './ShareFeedback.module.scss'

export function ShareFeedback({ open, onOpenChange, anchor, children }: Props) {
  const isMobile = useIsMobile()
  const { phase, handleSubmittingChange, handleSuccess } = useShareFeedbackPhase({ open, onOpenChange })
  const { handleInteractOutside } = useSuppressInitialOutsideInteraction(open)

  if (isMobile) {
    return <>{children}</>
  }

  return (
    <>
      <Popover.Root open={open} onOpenChange={onOpenChange}>
        <Popover.Anchor asChild>{anchor}</Popover.Anchor>
        <Popover.Portal>
          <Popover.Content
            data-testid={SHARE_FEEDBACK_TEST_IDS.root}
            className={styles.content}
            side="bottom"
            align="end"
            sideOffset={4}
            collisionPadding={8}
            onOpenAutoFocus={(event) => event.preventDefault()}
            onCloseAutoFocus={(event) => event.preventDefault()}
            onPointerDownOutside={handleInteractOutside}
            onFocusOutside={handleInteractOutside}
            onInteractOutside={handleInteractOutside}
          >
            <ShareFeedbackContent phase={phase} onSubmittingChange={handleSubmittingChange} onSuccess={handleSuccess} />
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
      {children}
    </>
  )
}
